import {Component, OnInit} from '@angular/core';
import {HttpStatusCode} from "@angular/common/http";
import {ActivatedRoute} from "@angular/router";
import {CustomMessageService, ResponseHttpError, ResponseHttpSuccess} from "library";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";

@Component({
  selector: 'app-sales-client-verification-start',
  templateUrl: './sales-client-verification-start.component.html'
})
export class SalesClientVerificationStartComponent implements OnInit {
  requestId: string;
  timeout: number = 3000;

  constructor(private route: ActivatedRoute,
              private customMessageService: CustomMessageService,
              private requestService: RequestService) {
    this.requestId = this.route.snapshot.params['request_id']
  }
  ngOnInit() {
    this.getClientVerificationStart();
  }

  getClientVerificationStart() {
    const domain = window.location.host.search('localhost') ?
      'https://' + window.location.host :
      'https://tiendas-develop-panama-dot-smartcredit2.ue.r.appspot.com';

    const callbackUrl = `${domain}/${window.location.pathname}?type=status`

    this.requestService.getClientVerificationStart(this.requestId, callbackUrl).subscribe({
      next: (resp: ResponseHttpSuccess) => {
        if(resp.status == HttpStatusCode.Ok) {
          setTimeout(() => window.location.replace(resp.body.data.url), this.timeout)
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
      },
      error: (error: ResponseHttpError) => {
        this.customMessageService.responseNoticeHandler(error);
      }
    });
  }
}
